import Type from "@/model/types/Type";

const type = {
    MANUAL: 1,
    CHECKLIST: 2,
}

const list = [
    {
        value: type.MANUAL,
        text: "Manual",
    },
    {
        value: type.LATE,
        text: "Inspeção",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}